import { StoryblokComponent } from "@storyblok/react";
import { FC, useCallback } from "react";

import { getFieldValues } from "@./state";
import { ComponentFieldConditions, InterpolationBehavior } from "@forms/schema";

interface ISectionComponents {
  components: any[]; // eslint-disable-line
  flowId: string;
  useConditionalLogic?: boolean;
  conditions?: ComponentFieldConditions[];
  canContinue?: boolean;
  linkingId?: string;
  interpolation?: InterpolationBehavior;
}

export const SectionComponents: FC<ISectionComponents> = (
  { components, flowId, useConditionalLogic, conditions, canContinue, linkingId, interpolation },
) => {
  const showComponents = useCallback((): boolean => {
    if (useConditionalLogic && conditions && conditions.length) {
      return conditions.filter((x) => x.conditional_name && x.conditional_value).every((condition) => {
        let condStoreValues = getFieldValues(flowId, condition.conditional_name ?? "");

        if (linkingId) {
          condStoreValues = condStoreValues.filter((value) => value.key.linkingId === linkingId);
        }
        return condStoreValues.some((condStoreValue) => (condStoreValue &&
          (condition.exclusionary
            ? condition.conditional_value === "ANY" ? !condStoreValue?.data?.submitValue : condStoreValue?.data?.submitValue?.toString().toLowerCase()
              !== condition.conditional_value?.toLowerCase()
            : condition.conditional_value === "ANY" ? !!condStoreValue?.data?.submitValue : condStoreValue?.data?.submitValue?.toString().toLowerCase()
              === condition.conditional_value?.toLowerCase())) ?? false);
      });
    }
    return true;
  }, [ conditions, flowId, useConditionalLogic ]);

  const areComponentsVisible = showComponents();
  return (
    <>
      <div data-component={ SectionComponents.name } className={ !areComponentsVisible ? "hidden" : "" }>
        { /* eslint-disable-next-line */ }
        { components?.map((nestedBlok: any) => (
          <StoryblokComponent
            blok={ nestedBlok }
            key={ nestedBlok._uid }
            flowId={ flowId }
            linkingId={ linkingId }
            interpolation={ interpolation }
            canContinue={ canContinue }
          />
        )) }
      </div>
    </>
  );
};
